export * from './TextAlignCenterIcon';
export * from './TextAlignCenterIcon16Light';
export * from './TextAlignCenterIcon16Regular';
export * from './TextAlignCenterIcon16Solid';
export * from './TextAlignCenterIcon20Light';
export * from './TextAlignCenterIcon20Regular';
export * from './TextAlignCenterIcon20Solid';
export * from './TextAlignCenterIcon24Regular';
export * from './TextAlignCenterIcon24Solid';
export * from './TextAlignCenterIcon32Regular';
export * from './TextAlignCenterIcon64Regular';
